import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'mat-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false,
})
export class StarRatingComponent implements OnInit {
  @Input() rating: number | undefined;
  @Input() starCount = 5;
  @Output() ratingUpdated = new EventEmitter();

  ratingArr: number[] = [];

  constructor() {}

  ngOnInit() {
    // for (let index = 0; index < this.starCount; index++) {
    //   this.ratingArr.push(index);
    // }
    this.ratingArr = Array(this.starCount)
      .fill(1)
      .map((x, i) => i);
  }
  onClick(rating: number) {
    this.ratingUpdated.emit(rating);
    return false;
  }

  showIcon(index: number) {
    if (this.rating && this.rating >= index + 1) {
      return 'star';
    } else {
      return 'star_border';
    }
  }
}
